import React from 'react';
// styles
import styled from 'styled-components';

const ShipmentUploadIcon = ({ className, ...props }) => (
  <svg
    {...props}
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Shipment Upload"
    className={className}
  >
    <path
      d="M8.43508 2.5995C8.43508 2.70181 8.51802 2.78475 8.62033 2.78475H12.5953C12.6704 2.78496 12.7382 2.73982 12.767 2.67046C12.7957 2.6011 12.7798 2.52124 12.7266 2.46825L10.5846 0.327752C10.3753 0.119365 10.0924 0.00164347 9.79708 1.62768e-06H8.62033C8.57075 -0.000206508 8.52316 0.0195543 8.48831 0.0548287C8.45346 0.090103 8.43428 0.137921 8.43508 0.187502V2.5995Z"
      fill="#FCC475"
    />
    <path
      d="M7.13606 2.78475C7.23837 2.78475 7.32131 2.70181 7.32131 2.5995V0.187502C7.32212 0.137921 7.30293 0.090103 7.26808 0.0548287C7.23323 0.0195543 7.18565 -0.000206508 7.13606 1.62768e-06H5.95931C5.66429 0.00104461 5.38148 0.117939 5.17181 0.325502L3.03206 2.46825C2.97886 2.52124 2.96291 2.6011 2.99167 2.67046C3.02044 2.73982 3.08823 2.78496 3.16331 2.78475H7.13606Z"
      fill="#FCC475"
    />
    <path
      d="M13.3062 6.9C13.3876 6.87853 13.4443 6.80491 13.4442 6.72075V4.08375C13.4442 3.98103 13.3609 3.89775 13.2582 3.89775H2.50019C2.45093 3.89775 2.4037 3.91737 2.36894 3.95227C2.33417 3.98718 2.31474 4.03449 2.31494 4.08375V10.7587C2.31536 11.3733 2.81342 11.8713 3.42794 11.8717H8.57519C8.66388 11.8719 8.74011 11.8089 8.75669 11.7217C9.24096 9.38432 11.0008 7.51915 13.3062 6.9Z"
      fill="#FCC475"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3006 11.071C11.0762 9.19922 12.903 7.97894 14.9291 7.97925C17.6941 7.98256 19.9347 10.2235 19.9376 12.9885C19.9376 15.0146 18.717 16.8412 16.8451 17.6165C14.9732 18.3918 12.8186 17.9631 11.386 16.5303C9.95343 15.0975 9.52504 12.9428 10.3006 11.071ZM14.1866 13.3597V15.4005C14.178 15.6713 14.3175 15.9252 14.5507 16.0631C14.7838 16.2011 15.0736 16.2011 15.3068 16.0631C15.5399 15.9252 15.6795 15.6713 15.6708 15.4005V13.3597C15.6713 13.2576 15.754 13.1749 15.8561 13.1745H16.7133C16.8535 13.1706 16.9798 13.0889 17.0407 12.9626C17.1016 12.8363 17.087 12.6866 17.0028 12.5745L15.2216 10.3477C15.1485 10.264 15.0428 10.216 14.9317 10.216C14.8206 10.216 14.7149 10.264 14.6418 10.3477L12.8606 12.5745C12.7764 12.6866 12.7618 12.8363 12.8227 12.9626C12.8837 13.0889 13.0099 13.1706 13.1501 13.1745H14.0013C14.1035 13.1749 14.1862 13.2576 14.1866 13.3597Z"
      fill="#FCC475"
    />
  </svg>
);

export default styled(ShipmentUploadIcon)``;
